import { Component, OnInit } from '@angular/core';
import { NavItem } from '../menu-item/nav-item';
import { GeneralComunicationService } from 'src/app/services/general-comunication.service';
import { Router } from '@angular/router';
import { StaticData } from 'src/app/helpers/static-data';
import PerfectScrollbar from 'perfect-scrollbar';

declare const $: any;
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
export const ROUTES: RouteInfo[] = [
  { path: '/Home', title: 'Inicio', icon: 'dashboard', class: '' },
  { path: '/Login', title: 'Login', icon: 'person', class: '' },
  { path: '/user-profile', title: 'Perfil de Usuario', icon: 'person', class: '' },
  { path: '/table-list', title: 'Table List', icon: 'content_paste', class: '' },
  { path: '/typography', title: 'Typography', icon: 'library_books', class: '' },
  { path: '/icons', title: 'Icons', icon: 'bubble_chart', class: '' },
  { path: '/maps', title: 'Maps', icon: 'location_on', class: '' },
  { path: '/notifications', title: 'Notifications', icon: 'notifications', class: '' },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  //Items Traidos del Menú inicial
  navItems: NavItem[] = [];
  verIDE: boolean = false;
  textoLogin = 'Iniciar sesión';

  constructor(public comunicationService: GeneralComunicationService, public router: Router) { }

  //------------------------------- Menú Inicial

  public NavegarLogin() {

    // this.modalLogin.open();
    if (this.textoLogin === 'Iniciar sesión') {
      this.comunicationService.raiseLoginEvent();
      this.textoLogin = 'Cerrar sesión';
    }
    else {
      this.textoLogin = 'Iniciar sesión';
      this.navItems = [];
      StaticData.Usuario = null;
      StaticData.Estilos = {};
      StaticData.ConfigPaginas = [];
      this.router.navigate(['Home']);
    }
  }

  public MenuInPos(eventElem) {
    console.log("menuInPos target: ", $(eventElem.target).parentsUntil('div'));
    $(".sidebar__text-inpos").toggleClass("sidebar__text-inpos");
    $(".inpos").toggleClass("inpos");
    $($(eventElem.target).parentsUntil('div')[$(eventElem.target).parentsUntil('div').length - 2]).toggleClass("inpos");
    if ($('span.active > a')["0"].hash) {
      $($('span.active > a')["0"].hash).collapse("toggle");
    }
    $(".active").toggleClass("active");
    $(".sidebar__text").toggleClass("sidebar__text-inpos");
  }

  public Navegar(item: NavItem) {

    this.router.navigate([item.menu.Ruta]);
  }
  public Menu(event) {
    if ($(event.currentTarget).attr('aria-expanded') != "true") {
      if ($(event.currentTarget).parent('.dropdown').children('a.dropdown-toggle').attr('aria-expanded') == 'false') {
        $('a.dropdown-toggle.nav-link').attr('aria-expanded', 'false');
        $('.show').removeClass('show')
      }
    }
  }
  get UsuarioActual(): string {
    //return (StaticData.Usuario) ? ' Usuario: ' + StaticData.Usuario.Nombre : 'Usuario:  Anonimo';
    return (StaticData.Usuario) ? StaticData.Usuario.Nombre : 'Anonimo';
  }

  //------------------------------- Fin Menú Inicial

  ngOnInit() {

    //------------------------------- Menú Inicial

    this.comunicationService.receivedNavItemsEvent.subscribe(navItems => {
      this.navItems = navItems;
      this.verIDE = true;
    });

    //------------------------------- Fin Menú Inicial

    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }

  ngAfterViewInit() {
    const elemMenu = document.querySelector('.sidebar') as HTMLElement;
    elemMenu.scrollTop = 0;
    let ps = new PerfectScrollbar(elemMenu);

    $(document).on('click', '#closemenu', function () {
      $('#responsive').removeClass('responsive')
      $('.sidebar').css({ 'left': '-66px', 'min-width': '0', 'max-width': '0' })
      $('#closemenu').remove();
    })
  }

  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }
}
